module.exports = __webpack_public_path__ + "img/7.c4b5eeeb.jpg";